import React, { useState, useEffect } from "react";
import { User, Lock, ArrowLeftCircle } from "react-feather"; // react-feather icons
import logo from "../assets/images/logo.png";
import { useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import apiPublic from "./ApiNoToken";

function Otp() {
  const [formData, setFormData] = useState({ otp: "" });
  const [timeLeft, setTimeLeft] = useState(0);
  const navigate = useNavigate();

  useEffect(() => {
    // Ambil expired_at dari localStorage
    const expiredAt = localStorage.getItem("otpExpiredAt");

    if (expiredAt) {
      const expiredTime = new Date(expiredAt).getTime();
      const now = new Date().getTime();
      const diff = Math.floor((expiredTime - now) / 3000); // detik

      if (diff > 0) {
        setTimeLeft(diff);
      } else {
        setTimeLeft(0); // sudah expired
      }
    }
  }, []);

  // Timer countdown
  useEffect(() => {
    if (timeLeft <= 0) return;

    const interval = setInterval(() => {
      setTimeLeft((prev) => {
        if (prev <= 1) {
          clearInterval(interval);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(interval);
  }, [timeLeft]);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault(); // biar tidak reload halaman
    const otpValue = formData.otp.trim();
    const email = localStorage.getItem("resetEmail");

    if (!email) {
      toast.error("Email tidak ditemukan, silakan ulangi proses.");
      navigate("/ForgotPassword");
      return;
    }

    // Validasi kosong
    if (otpValue === "") {
      toast.warning("Kode OTP wajib diisi.");
      return;
    }

    // Validasi hanya angka
    const numberPattern = /^[0-9]+$/;
    if (!numberPattern.test(otpValue)) {
      toast.error("Kode OTP hanya boleh berisi angka.");
      return;
    }

    // Validasi panjang 6 digit
    if (otpValue.length !== 6) {
      toast.error("Kode OTP harus 6 digit angka.");
      return;
    }

    try {
      const res = await apiPublic.post("/verify-otp", {
        email,
        kode_otp: otpValue,
      });

      console.log("Verifikasi OTP sukses:", res.data);

      // Kalau sukses, arahkan ke halaman reset password
      toast.success("OTP valid, silakan reset password.");
      navigate("/Verifikasi");
    } catch (err) {
      console.error("Verifikasi OTP gagal:", err.response || err);
      toast.error(
        err.response?.data?.message || "OTP tidak valid atau sudah kadaluarsa."
      );
    }
  };

  return (
    <div id="auth">
      <div className="container">
        <div className="row">
          <div className="col-md-5 col-sm-12 mx-auto">
            <div className="card pt-4">
              <div className="card-body">
                <div className="text-center mb-5">
                  <img src={logo} height="80" className="mb-4" alt="logo" />
                  <h3
                    style={{
                      fontFamily: '"Arial Black", "Arial", sans-serif',
                      fontWeight: "bold",
                      color: "#1a237e", // Biru tua, bisa disesuaikan
                      textTransform: "uppercase",
                      marginBottom: "0.2rem",
                    }}
                  >
                    PERUMDAM TKR
                  </h3>
                  <p
                    style={{
                      fontFamily: '"Arial Black", "Arial", sans-serif',
                      color: "#555555", // Abu-abu gelap
                      textTransform: "uppercase",
                      fontWeight: "normal",
                      fontSize: "0.9rem",
                      marginTop: "0",
                    }}
                  >
                    KABUPATEN TANGERANG
                  </p>
                  <p>Masukkan Kode OTP</p>

                  <p style={{ fontWeight: "bold", color: "#d32f2f" }}>
                    {timeLeft > 0
                      ? `Kode OTP berlaku ${Math.floor(timeLeft / 60)}:${String(
                          timeLeft % 60
                        ).padStart(2, "0")}`
                      : "Kode OTP sudah kadaluarsa"}
                  </p>
                </div>

                <form onSubmit={handleSubmit}>
                  <div className="form-group position-relative has-icon-left">
                    <label htmlFor="username">Kode OTP</label>
                    <div className="position-relative">
                      <input
                        type="text"
                        className="form-control"
                        id="otp"
                        name="otp"
                        placeholder="Masukkan Kode OTP Anda"
                        value={formData.otp}
                        onChange={handleChange}
                        maxLength={6}
                      />
                      <div className="form-control-icon">
                        <Lock size={16} />
                      </div>
                    </div>
                  </div>

                  <div className="form-check clearfix my-4">
                    <div className="float-right"></div>
                    <div className="float-left"></div>
                  </div>
                  <div className="clearfix">
                    <button
                      className="btn btn-secondary float-left"
                      type="button"
                      onClick={() => window.history.back()}
                    >
                      <ArrowLeftCircle
                        size={16}
                        style={{ marginRight: "8px" }}
                      />
                      Back
                    </button>
                    <button
                      className="btn btn-primary float-right"
                      type="submit"
                    >
                      Submit
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ToastContainer position="top-right" autoClose={3000} />
    </div>
  );
}

export default Otp;
